import { RSAA, RSAAAction } from 'redux-api-middleware'
import { ActionCreator } from 'redux'
import { Env, getEnv } from '@cinch/oxd-utils/env/src'

import {
  PARTEX_CLEAR_VALUATION,
  PARTEX_CREATE_VALUATION_REQUEST,
  PARTEX_CREATE_VALUATION_COMPLETE,
  PARTEX_CREATE_VALUATION_ERROR,
  PARTEX_VARIANTS_REQUEST,
  PARTEX_VARIANTS_COMPLETE,
  PARTEX_VARIANTS_ERROR,
  PARTEX_UPDATE_APPRAISAL,
  PARTEX_UPDATE_VRM,
  PARTEX_VARIANT_SELECT,
} from '../types'

import { PartexVehicleVariant, PartexState, PartexAppraisalQuestions } from '../reducers/partex'

const PARTEX_SERVICE_URL = getEnv(Env.PartExServiceUrl)

export const clearPartexValuation = () => {
  return {
    type: PARTEX_CLEAR_VALUATION,
  }
}

export const getPartexVariants: ActionCreator<RSAAAction> = (vrm: string) => {
  return {
    [RSAA]: {
      endpoint: `${PARTEX_SERVICE_URL}/variant/${vrm}`,
      method: 'GET',
      types: [PARTEX_VARIANTS_REQUEST, PARTEX_VARIANTS_COMPLETE, PARTEX_VARIANTS_ERROR],
    },
  }
}

export const updatePartexAppraisal = (appraisalQuestions: PartexAppraisalQuestions) => {
  return {
    type: PARTEX_UPDATE_APPRAISAL,
    payload: appraisalQuestions,
  }
}

export const updatePartexVRM = (vrm: string) => {
  return {
    type: PARTEX_UPDATE_VRM,
    payload: vrm,
  }
}

export const selectPartexVehicleVariant = (variant: PartexVehicleVariant) => {
  return {
    type: PARTEX_VARIANT_SELECT,
    payload: variant,
  }
}

export const createPartexValuation: ActionCreator<RSAAAction> = () => {
  return {
    [RSAA]: {
      endpoint: `${PARTEX_SERVICE_URL}/valuation/create`,
      method: 'POST',
      body: ({ checkout: { partex } }: { checkout: { partex: PartexState } }) =>
        JSON.stringify({
          appraisalQuestions: {
            registeredKeepers: partex.registeredKeepers,
            vehicleCondition: partex.vehicleCondition,
          },
          capId: partex.variant?.capId,
          mileage: partex.mileage,
          registrationDate: partex.variant?.registrationDate,
          vrm: partex.vrm,
        }),
      types: [PARTEX_CREATE_VALUATION_REQUEST, PARTEX_CREATE_VALUATION_COMPLETE, PARTEX_CREATE_VALUATION_ERROR],
    },
  }
}
